import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { TrackingTemplates } from './initValues';

const ShortAnswerSurveyTracking: FC = () => {
  const currentBranchIndex = useSelector(
    (state: RootState) => state.imageUpload.currentBranchIndex
  );

  const style = `
    .root_tracking {
      background: none;

      .center_horizon {
        width: 100%;
      }
      .logo {
        opacity: 0;
      }

      .center_wrapper {
        width: 100%;
        padding: 0;
      }
      .hr {
        opacity: 0;
      }

      .textarea {
        padding: 0;
        background: transparent;
      }

      .bottom {
        height: auto;
        flex-direction: column;
      }
      .bottom button {
        height: auto;
        background: none;
      }
      
      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      {TrackingTemplates[currentBranchIndex]}
    </>
  );
};

export default ShortAnswerSurveyTracking;
